import type { CSSObject } from "type/tss";
import { Theme } from "@mui/material/styles";

export const styles = (theme: Theme) =>
	({
		sectionHeading: {
			fontWeight: 600,
			marginBottom: 4,
			fontSize: 18
		},
		sectionSubheading: {
			fontSize: 16,
			fontWeight: "bold",
			color: theme.palette.custom.textPrimary,
			marginBottom: 8,
		},
		sectionDescription: {
			color: theme.palette.custom.textPrimary,
			marginTop: 8,
		},
		sectionDivider: {
			marginTop: 12,
			marginBottom: 12,
		},
		infoIcon: {
			display: "inline-flex",
			alignItems: "center",
			marginLeft: 8,
			color: theme.palette.text.secondary,
			cursor: "default",
		},
		textFieldLabel: {
			marginBottom: 4,
		},
		fieldLabelRow: {
			marginBottom: 4,
		},
		newBadge: {
			fontWeight: 700,
			fontSize: 10,
			height: 18,
		},
		pageSubtitle: {
			marginBottom: 32,
			color: theme.palette.text.secondary,
		},
		// The Disclaimer Type block sits indented under the toggle, aligned with the toggle's
		// label column rather than the section edge.
		disclaimerTypeIndent: {
			marginLeft: 64,
			marginTop: 24,
		},
		disclaimerTypeHeading: {
			fontWeight: "bold",
			marginBottom: 8,
		},
		textingEnabledDescription: {
			color: theme.palette.custom.textPrimary,
			marginBottom: 24,
		},
		radioOption: {
			marginBottom: 16,
			"&:last-child": {
				marginBottom: 0,
			},
		},
		radioControl: {
			marginBottom: 0,
		},
		radioLabel: {
			fontWeight: "bold",
		},
		// Aligns the description and "View Text" link with the radio label text, clearing the
		// 24px control plus its gap.
		radioLabelColumn: {
			marginLeft: 46,
		},
		radioDescription: {
			color: theme.palette.custom.textPrimary,
			marginBottom: 4,
		},
	} satisfies Record<string, CSSObject>);
